import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProfileEditModal from '../user/ProfileEditModal';

const API_URL = process.env.REACT_APP_API_URL;

const AdminProfileSettings = () => {
  const [adminUser, setAdminUser] = useState(null);
  const [showProfileEditModal, setShowProfileEditModal] = useState(false);
  const [occupations, setOccupations] = useState([]);
  const [annualIncomes, setAnnualIncomes] = useState([]);
  const [profileData, setProfileData] = useState({
    currentPassword: '',
    newPassword: '',
    name: '',
    birthday: '',
    address: '',
    photoLink: '',
    occupation: '',
    annual_income: ''
  });

  useEffect(() => {
    fetchAdminUser();
    fetchOccupations();
    fetchAnnualIncomes();
  }, []);

  const fetchAdminUser = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAdminUser(response.data);
      setProfileData({
        currentPassword: '',
        newPassword: '',
        name: response.data.name || '',
        birthday: response.data.birthday || '',
        address: response.data.address || '',
        photoLink: response.data.photoLink || '',
        occupation: response.data.occupation?._id || '',
        annual_income: response.data.annual_income?._id || ''
      });
    } catch (error) {
      console.error('Error fetching admin user:', error);
      alert('管理者情報の取得に失敗しました');
    }
  };

  const fetchOccupations = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/occupations`);
      setOccupations(response.data);
    } catch (error) {
      console.error('Error fetching occupations:', error);
    }
  };

  const fetchAnnualIncomes = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/annual-incomes`);
      setAnnualIncomes(response.data);
    } catch (error) {
      console.error('Error fetching annual incomes:', error);
    }
  };

  const handleEditProfile = () => {
    setShowProfileEditModal(true);
  };

  const handleProfileUpdate = (updatedUser) => {
    setAdminUser(updatedUser);
  };

  return (
    <div>
      <h2 style={{ color: '#333', marginBottom: '20px' }}>管理者プロフィール設定</h2>
      {adminUser && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <h3 style={{ 
            backgroundColor: '#ff6b35', 
            color: 'white', 
            padding: '10px',
            margin: '-20px -20px 20px -20px',
            borderRadius: '8px 8px 0 0'
          }}>
            プロフィール情報
          </h3>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            {adminUser?.photoLink ? (
              <img 
                src={adminUser?.photoLink?.photodatas || adminUser?.photoLink} 
                alt="Profile" 
                style={{ 
                  width: '80px', 
                  height: '80px', 
                  borderRadius: '50%', 
                  marginRight: '20px',
                  objectFit: 'cover'
                }} 
              />
            ) : (
              <div style={{ 
                width: '80px', 
                height: '80px', 
                borderRadius: '50%', 
                backgroundColor: '#ddd',
                marginRight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                写真なし
              </div>
            )}
            <div>
              <p><strong>名前:</strong> {adminUser.name || '未設定'}</p>
              {/* <p><strong>ユーザーID:</strong> {adminUser.userID}</p> */}
              {/* <p><strong>メール:</strong> {adminUser.email}</p>
              <p><strong>誕生日:</strong> {adminUser.birthday || '未設定'}</p>
              <p><strong>住所:</strong> {adminUser.address || '未設定'}</p>
              <p><strong>職業:</strong> {adminUser.occupation?.occupaionName || '未設定'}</p>
              <p><strong>年収:</strong> {adminUser.annual_income?.annualIncome || '未設定'}</p> */}
            </div>
          </div>

          <button 
            onClick={handleEditProfile}
            style={{
              backgroundColor: '#ff6b35',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            プロフィール編集
          </button>
        </div>
      )}

      <ProfileEditModal
        showModal={showProfileEditModal}
        onClose={() => {setShowProfileEditModal(false), fetchAdminUser()}}
        user={adminUser}
        profileData={profileData}
        setProfileData={setProfileData}
        occupations={occupations}
        annualIncomes={annualIncomes}
        onProfileUpdate={handleProfileUpdate}
      />
    </div>
  );
};

export default AdminProfileSettings; 